"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var date_parser_1 = __importDefault(require("../../../common/src/utils/date/date_parser"));
var value_checker_1 = __importDefault(require("../../../common/src/utils/validation/value_checker"));
exports.default = {
    name: 'DatePickerWrapper',
    props: ['value', 'name', 'disabled', 'error', 'label', 'hint', 'type', 'classes', 'editable', 'min', 'max'],
    data: function () {
        return {
            lang: 'ja-jp',
            showDialog: false,
            dateValue: null
        };
    },
    mounted: function () {
        if (value_checker_1.default.isPresent(this.value)) {
            this.dateValue = this.value;
        }
        else {
            this.dateValue = null;
        }
    },
    watch: {
        value: function (newVal) {
            if (value_checker_1.default.isPresent(this.value)) {
                this.dateValue = newVal;
            }
            else {
                this.dateValue = null;
            }
        },
        dateValue: function (newVal) {
            this.updateParents(newVal);
        }
    },
    computed: {
        dateStr: function () {
            if (value_checker_1.default.isPresent(this.dateValue)) {
                if (this.type === 'month') {
                    return date_parser_1.default.toJapaneseDateStrNenGetu(this.dateValue);
                }
                else {
                    return date_parser_1.default.toJapaneseDateStr(this.dateValue);
                }
            }
            return '';
        }
    },
    methods: {
        /**
         * 親要素を更新
         * @param newVal
         */
        updateParents: function (newVal) {
            this.$emit('input', newVal);
        },
        updateDateValue: function (newVal) {
            this.dateValue = newVal;
        },
        dateChange: function () {
            this.$refs.dialog.save(this.dateValue);
        }
    }
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/datepicker/DatePickerWrapper.vue
// module id = iiN9
// module chunks = 1